import React from 'react';

const videoCall = React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30", fill: "none" },
    React.createElement("path", { d: "M3 8.25C3 6.17893 4.67893 4.5 6.75 4.5H18.75C20.8211 4.5 22.5 6.17893 22.5 8.25V21.75C22.5 23.8211 20.8211 25.5 18.75 25.5H6.75C4.67893 25.5 3 23.8211 3 21.75V8.25Z", fill: "#121212" }),
    React.createElement("path", { d: "M21 13.1185C21 12.6806 21.1913 12.2646 21.5238 11.9796L26.0238 8.12245C26.9968 7.28844 28.5 7.9798 28.5 9.26133V20.7387C28.5 22.0202 26.9968 22.7116 26.0238 21.8776L21.5238 18.0204C21.1913 17.7354 21 17.3194 21 16.8815V13.1185Z", fill: "#121212" }));

export { videoCall };
//# sourceMappingURL=video_call.js.map
